import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid-pro';
import { Document } from '@api/Trinium/Endpoints/Document';
import StackedTextCell from '@components/DataGrid/ColumnDefinitions/StackedTextCell';
import RenderHeader from '@components/DataGrid/RenderHeader';
import DocumentMobileItem from './DocumentMobileItem';

import gridStyles from '@components/DataGrid/RenderCell.module.css';
import styles from './DataGrid.DocumentControl.module.css';

export const documentControlColumnDefinitions: GridColDef<Document>[] = [
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF,
		resizable: false
	},
	{
		field: 'id',
		width: 110,
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Document ID' />
	},
	{
		field: 'type',
		flex: 1,
		minWidth: 125,
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Document Type' />
	},
	{
		field: 'jobId',
		width: 80,
		headerClassName: styles['grid-column-header'],
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Order' />
	},
	{
		field: 'cntrId',
		width: 125,
		headerClassName: styles['grid-column-header'],
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Container' />
	},
	{
		field: 'chassisId',
		width: 120,
		headerClassName: styles['grid-column-header'],
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Chassis No.' />
	},
	{
		field: 'puName',
		flex: 1,
		minWidth: 125,
		headerClassName: styles['grid-column-header'],
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Pickup' />
	},
	{
		field: 'delvName',
		flex: 1,
		minWidth: 125,
		headerClassName: styles['grid-column-header'],
		sortable: true,
		disableReorder: true,
		renderHeader: () => <RenderHeader primaryText='Delivery' />
	},
	{
		field: 'customer',
		flex: 1,
		minWidth: 175,
		sortable: true,
		disableReorder: true,
		cellClassName: gridStyles.cell,
		valueGetter: (_value, row) => {
			return `${row.custName} ${row.csnCustRefNo ?? ''}`;
		},
		renderHeader: () => (
			<RenderHeader
				primaryText='Customer'
				secondaryText='Ref #'
			/>
		),
		renderCell: ({ row }) => (
			<StackedTextCell
				primaryText={row.custName}
				secondaryText={row.csnCustRefNo}
			/>
		)
	}
];

export const mobileDocumentControlColumnDefs: GridColDef<Document>[] = [
	{
		...GRID_CHECKBOX_SELECTION_COL_DEF
	},
	{
		field: 'Mobile Card',
		flex: 1,
		minWidth: 150,
		headerAlign: 'right',
		sortable: false,
		disableReorder: true,
		renderHeader: () => <></>,
		renderCell: (props) => <DocumentMobileItem {...props} />
	}
];
